import type { UserPresence } from "@workith/shared";
import { Avatar, AvatarFallback } from "@workith/ui";
import { Users } from "lucide-react";

interface User {
  name: string;
  color: string;
}

export interface UserState {
  clientId: number;
  user: User;
  cursor?: UserPresence["cursor"];
}

interface UserListProps {
  users: UserState[];
  currentUser: User;
}

export default function UserList({ users, currentUser }: UserListProps) {
  const getInitials = (name: string) => {
    return name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  const otherUsers = users.filter((userState) => userState.user.name !== currentUser.name);
  const allUsers = [{ user: currentUser, clientId: -1 }, ...otherUsers];

  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-1 text-sm text-muted-foreground">
        <Users className="h-4 w-4" />
        <span>{allUsers.length}명 접속 중</span>
      </div>

      <div className="flex items-center -space-x-2">
        {allUsers.map((userState, index) => (
          <Avatar
            key={userState.clientId}
            className="h-8 w-8 border-2 border-background"
            style={{
              zIndex: allUsers.length - index,
            }}
          >
            <AvatarFallback
              className="text-xs font-medium"
              style={{
                backgroundColor: userState.user.color,
                color: "#fff",
              }}
            >
              {getInitials(userState.user.name)}
            </AvatarFallback>
          </Avatar>
        ))}
      </div>
    </div>
  );
}
